/*
 *  Skeleton.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import styled, { keyframes, css } from "styled-components";
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const loadingAnimation = keyframes`
  0% {
    background-color: #f0f0f1;
  }
  50% {
    background-color: #DCDCDD;
  }
  100% {
    background-color: #f0f0f1;
  }
`;

const Skeleton = styled.div`
  width: ${(props) => props.width || "20px"};
  height: ${(props) => props.height || "600px"};
  border-radius: ${(props) => props.borderRadius || "6px"};
  margin: ${(props) => props.margin || "0"};
  animation: ${css`
    ${loadingAnimation} 3s ease-in-out infinite
  `};
`;

export default Skeleton;
